import Page from "./components/page/Page";

const WebWorkFlowMain = ({isRowClicked, setIsRowClicked}) => {
  return <Page isRowClicked={isRowClicked} setIsRowClicked={setIsRowClicked}/>;
};

export default WebWorkFlowMain;
